var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "p-3 settings-panel shadow rounded" }, [
    _c("div", { staticClass: "form-group" }, [
      _c("strong", [_vm._v(_vm._s(_vm.$t("map.history.settings.title")))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "dateFrom" + _vm.uid } }, [
        _vm._v(_vm._s(_vm.$t("map.history.settings.fromDate")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.dateFromForInput,
            expression: "dateFromForInput"
          }
        ],
        staticClass: "form-control",
        attrs: { id: "dateFrom" + _vm.uid, type: "datetime-local" },
        domProps: { value: _vm.dateFromForInput },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.dateFromForInput = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "dateTo" + _vm.uid } }, [
        _vm._v(_vm._s(_vm.$t("map.history.settings.toDate")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.dateToForInput,
            expression: "dateToForInput"
          }
        ],
        staticClass: "form-control",
        attrs: { id: "dateTo" + _vm.uid, type: "datetime-local" },
        domProps: { value: _vm.dateToForInput },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.dateToForInput = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "dateCurrent" + _vm.uid } }, [
        _vm._v(_vm._s(_vm.$t("map.history.settings.currentDate")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "time-slider" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.secondsCurrent,
              expression: "secondsCurrent"
            }
          ],
          staticClass: "form-control-range",
          attrs: {
            id: "dateCurrent" + _vm.uid,
            type: "range",
            min: "0",
            max: _vm.rangeSeconds
          },
          domProps: { value: _vm.secondsCurrent },
          on: {
            __r: function($event) {
              _vm.secondsCurrent = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.formatDateTime(_vm.dateCurrent)))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }